import React, { useEffect, useState } from "react";
import RubricCompoment from "./rubricComponent";
import ModalMenu from "components/Modals";
import { useRubrices } from "store/rubric/selectors";
import { handleDeleteRubric } from "store/rubric/thunks";
import { useCurrentUser } from "store/users/selectors";
import { useDispatch } from "react-redux";
import { filter } from "lodash";
import SentryWrap from 'components/Sentry';
const Rubric = ({ from }) => {
  const data = useRubrices();
  const dispatch = useDispatch();
  const [states, setStates] = useState({
    rubricForm: { open: false, form: "" },
    rubricData: data || [],
    editRubric: null,
    selectedRubric: {},
    currentUser: useCurrentUser(),
    loader: false,
    filteredResult: [],
  });

  const updateStates = (key, value) => {
    if (!key) {
      return;
    }
    setStates((prev) => {
      if (typeof key === "string" && key.includes(".")) {
        const [parentKey, childKey] = key.split(".");
        return {
          ...prev,
          [parentKey]: {
            ...prev[parentKey],
            [childKey]: value,
          },
        };
      }
      return { ...prev, [key]: value };
    });
  };

  const deleteHandler = async (rubricId) => {
    updateStates("loader", true);
    await dispatch(handleDeleteRubric(rubricId));
    updateStates("loader", false);
  };

  useEffect(() => {
    if(from=="placement"){
      const placement_data = filter(data,k=>k.is_placement)
      updateStates("rubricData", placement_data);
      updateStates("filteredResult", placement_data);
    }else{
      const placement_data = filter(data,k=>!k.is_placement)
      updateStates("rubricData", placement_data);
      updateStates("filteredResult", placement_data);
    }
  }, [data,from]);

  return (
    <SentryWrap>
      <RubricCompoment
        states={states}
        from={from}
        funcObject={{
          updateStates,
          deleteHandler,
        }}
      />
      <ModalMenu
        // create rubric or other modal
        type={states?.rubricForm?.form}
        open={states?.rubricForm?.open}
        close={() => {
          updateStates("editRubric", null);
          updateStates("selectedRubric", {});
          updateStates("rubricForm", { open: false, form: "" });
        }}
        is_placement={from=="placement"}
        //edit rubric modal
        editRubric={states?.selectedRubric}
        setEditRubric={() => updateStates("selectedRubric", {})}
        // preview rubric modal
        rubrics_meta={states?.selectedRubric?.rubrics_meta}
        mainTitle={states?.selectedRubric?.title}
        // close confirmation modal
        messageTitle="Are you sure you want delete this rubric"
        actionOnOk={() => deleteHandler(states?.selectedRubric?.id)}
      />
    </SentryWrap>
  );
};

export default Rubric;
